<div *ngIf="showFilter" fxLayout="row" fxLayoutAlign="top left">
	<app-capacity-search-filter
		(filteredList)="
			updateFilteredList($event);
			setCarrierFilter();
			initialiseUpgradeProMsg();
			updatePannelHeader()
		"
		(isRequestInProgress)="isRequestInProgress.emit($event)"
		(noNetworkCarriersMsg)="noNetworkCarriersMsg = $event"
		(isSearchRefined)="getSearchRefined($event)"
		[capacitySearchResults]="capacitySearchResults"
		[customerCarrierMatched]="isCustomerCarrierMatched"
		[emailByTruckIds]="emailByTruckIds"
		[inNetworkCarrierCountForSearch]="inNetworkCarrierCountForSearch"
		[lanePricing]="lanePricing"
		[matchedCarriers]="matchedCarriers"
		[matchedCarrierIds]="matchedCarrierIds"
		[searchTruckForm]="searchTruckForm"
		[truckLaneSearchId]="truckLaneSearchId"
		[truckSearchId]="truckSearchId"
		[truckSearchIds]="truckSearchIds"
		[truckSearchResultCopy]="truckSearchResultCopy"
		[isCityMissing]="isCityMissing"
		fxFlex="100"
	>
	</app-capacity-search-filter>
</div>

<div
	*ngIf="showFilter && (utilService.isAccountTypeBroker() || utilService.isAccountTypeShipper())"
	class="m-t-1"
	fxLayout="row"
>
	<div fxFlex>
		<app-deadhead-sliders
			(sliderChange)="sliderChange.emit()"
			[destinationSliderDisabled]="searchTruckForm && IS_EMPTY(searchTruckForm?.destination?.city)"
			[isLoadingSearchResults]="isTruckSearch"
			[lanePricing]="lanePricing"
			[originSliderDisabled]="searchTruckForm && IS_EMPTY(searchTruckForm?.origin?.city)"
			[showRecentTransactionsCard]="pricingComponent?.showRecentTransactionsCard"
		></app-deadhead-sliders>
	</div>
	<div fxFlex="20">
		<app-power-units-filter
			(trucksCountChange)="trucksCountChange.emit($event)"
			[isLoadingSearchResults]="isTruckSearch"
			[searchTruckForm]="searchTruckForm"
		>
		</app-power-units-filter>
	</div>
	<div fxFlex="20">
		<app-frequency-filter
			(sliderChange)="sliderChange.emit()"
			[isLoadingSearchResults]="isTruckSearch"
			[searchTruckForm]="searchTruckForm"
		>
		</app-frequency-filter>
	</div>
</div>

<div *ngIf="!utilService.isNullOrUndefined(truckSearchResult); else skeletonLoader" class="h-100">
	<div class="font-size-12 label-text-light my-2" fxLayout="row" *ngIf="showTotalCount && !isKanbanView">
		<div *ngIf="showDragCarrierText" fxFlex>
			{{ dragCarrierText }}
		</div>
		<div fxFlex fxLayoutAlign="{{ showDragCarrierText ? 'end center' : 'start start' }}">
			{{ totalSearchLength }} Matching {{ totalSearchLength > 1 ? 'Carriers' : 'Carrier' }}
		</div>
	</div>

	<!-- CN-8312: Kanban View - Compact card layout for V3 -->
	<div *ngIf="isKanbanView" class="kanban-cards-container h-100">
		<cdk-virtual-scroll-viewport
			itemSize="85"
			[minBufferPx]="200"
			[maxBufferPx]="300"
			class="h-100"
		>
			<div
				*cdkVirtualFor="let search of capacitySearchResults | slice: lowValue : highValue; let i = index"
				(click)="panelClicked(search, $event, false, i)"
				(dragend)="dragend()"
				(dragstart)="drag($event, search)"
				[dragData]="search"
				dragImage="assets/icons/drag_indicator.svg"
				dragTransitClass="no-border"
				draggable
				class="kanban-card"
				[ngClass]="{
					'kanban-card-selected':
						(isCapacitySearch && selectedMatch?.carrierId == search.carrierId) ||
						(hideLastColumn && selectedKanbanCarrierId === search.carrierId),
					'kanban-card-multiselect': isMultiselectEnabled && selectedCarrierIds.indexOf(search.carrierId) > -1
				}"
				[attr.id]="search.carrierId"
			>
				<app-pannel-header
					#pannelHeaders
					(loadMoreProjects)="loadMoreProjects.emit()"
					(notesDialogClosed)="afterNotesDialogClose($event)"
					(openLaneDetails)="openLaneDetails.emit($event)"
					(panelClicked)="panelClicked($event.search, $event.mouseEvent, $event.isCheckCircleClicked, i)"
					(projectToggled)="updateTruckSearchResultsCopy($event)"
					[addCarriersToProject]="addCarriersToProject"
					[allProjectsList]="allProjectsList"
					[carrierToProjectsMap]="
						utilService.isNullOrUndefined(carrierProjectMap[search.carrierId])
							? []
							: carrierProjectMap[search.carrierId]
					"
					[filters]="filters"
					[isLoadingProjectsList]="isLoadingProjectsList"
					[isMultiselectEnabled]="isMultiselectEnabled"
					[projectsNextPage]="projectsNextPage"
					[searchResult]="search"
					[searchTruckForm]="searchTruckForm"
					[selectedCarrierIds]="selectedCarrierIds"
					[showFMCSA]="false"
					[totalNumberOfProjects]="totalNumberOfProjects"
					[truckLaneSearchId]="truckLaneSearchId"
					[userCarrierMapList]="userCarrierMapList"
					[userCarrierMap]="userCarrierMap"
					[usersList]="usersList"
					[allUsersList]="allUsersList"
					[customerCarrier]="search.customerCarrier"
					[isCarrierVettingIntegrationEnabled]="isCarrierVettingIntegrationEnabled"
					[isCarrierOnboarded]="carrierVettingService.isCarrierOnboarded(search.carrierId)"
					[isExpanded]="false"
					[hideLastColumn]="hideLastColumn"
					[isKanbanView]="true"
				>
				</app-pannel-header>
			</div>
		</cdk-virtual-scroll-viewport>
	</div>

	<!-- Standard View (V1/V2/V3 non-Kanban) -->
	<div
		*ngIf="!isKanbanView"
		class="h-100"
		[ngClass]="{
			capacity_search_pannel_wrapper_container: isCapacitySearchPage,
			recommended_tab_pannel_wrapper_container: isRecommendedTab,
		}"
	>
		<cdk-virtual-scroll-viewport
			itemSize="125"
			[minBufferPx]="450"
			[maxBufferPx]="550"
			class="h-100"
		>
			<mat-accordion fxFlex="100">
				<div
					*cdkVirtualFor="
						let search of capacitySearchResults | slice: lowValue : highValue;
						let i = index
					"
					fxLayout="row"
					fxLayoutAlign="start stretch"
					[ngStyle]="{ 'margin-top': i > 0 ? (hideLastColumn ? '0.5rem' : '1rem') : 0 }"
					class="v2-card-row"
				>
					<!-- CN-8312 V2: leading bulk-select gutter (outside the card) -->
					<div *ngIf="showBulkSelectGutter" class="v2-bulk-select-gutter" (click)="$event.stopPropagation()">
						<mat-checkbox
							color="primary"
							[checked]="bulkSelectedCarrierIds.indexOf(search.carrierId) > -1"
							(change)="emitBulkSelectToggle(search)"
							(click)="$event.stopPropagation()"
							aria-label="Select carrier"
						></mat-checkbox>
					</div>
					<mat-expansion-panel
						#panel
						fxFlex
						(dragend)="dragend()"
						(dragstart)="drag($event, search)"
						[dragData]="search"
						dragImage="assets/icons/drag_indicator.svg"
						[expanded]="step == i"
						[class.is-expanded]="step === i"
						[hideToggle]="true"
						[ngClass]="{
							'mat-elevation-z4 primary-border':
								isCapacitySearch && selectedMatch?.carrierId == search.carrierId,
							'panel-selected mat-elevation-z4':
								(isMultiselectEnabled && selectedCarrierIds.indexOf(search.carrierId) > -1) ||
								(showBulkSelectGutter && bulkSelectedCarrierIds.indexOf(search.carrierId) > -1),
						}"
						class="custom-panel mat-elevation-z1"
						dragTransitClass="no-border"
						draggable
						id="{{ search.carrierId }}"
					>
						<!-- V1 only: legacy check-icon multi-select span (V2 uses leading gutter) -->
						<span
							(click)="$event.stopPropagation(); panelClicked(search, $event, true, i)"
							*ngIf="isMultiselectEnabled && !hideLastColumn"
							class="selection"
							matTooltip
						>
							<mat-icon>check_circle</mat-icon>
						</span>
					<span
						(click)="$event.stopPropagation(); panelClicked(search, $event, false, i)"
						*ngIf="addCarriersToProject"
						[ngStyle]="{
							color: selectedCarrierIds.indexOf(search.carrierId) == -1 ? 'grey' : '#103459',
						}"
						class="selection-right"
						matTooltip
					>
						<mat-icon>check_circle</mat-icon>
					</span>

					<mat-expansion-panel-header
						(click)="$event.stopImmediatePropagation(); panelClicked(search, $event, false, i)"
						(keydown.arrowdown)="$event.stopImmediatePropagation()"
						(keydown.arrowup)="$event.stopImmediatePropagation()"
						(keydown.enter)="$event.stopImmediatePropagation()"
						[collapsedHeight]="isKanbanView ? '85px' : '125px'"
						[expandedHeight]="isKanbanView ? '85px' : '155px'"
						fxLayout="row"
						fxLayoutAlign="start stretch"
					>
						<app-pannel-header
							#pannelHeaders
							(loadMoreProjects)="loadMoreProjects.emit()"
							(notesDialogClosed)="afterNotesDialogClose($event)"
							(openLaneDetails)="openLaneDetails.emit($event)"
							(panelClicked)="
								panelClicked($event.search, $event.mouseEvent, $event.isCheckCircleClicked, i)
							"
							(projectToggled)="updateTruckSearchResultsCopy($event)"
							[addCarriersToProject]="addCarriersToProject"
							[allProjectsList]="allProjectsList"
							[carrierToProjectsMap]="
								utilService.isNullOrUndefined(carrierProjectMap[search.carrierId])
									? []
									: carrierProjectMap[search.carrierId]
							"
							[filters]="filters"
							[isLoadingProjectsList]="isLoadingProjectsList"
							[isMultiselectEnabled]="isMultiselectEnabled"
							[projectsNextPage]="projectsNextPage"
							[searchResult]="search"
							[searchTruckForm]="searchTruckForm"
							[selectedCarrierIds]="selectedCarrierIds"
							[showFMCSA]="step == i && showFMCSA"
							[totalNumberOfProjects]="totalNumberOfProjects"
							[truckLaneSearchId]="truckLaneSearchId"
							[userCarrierMapList]="userCarrierMapList"
							[userCarrierMap]="userCarrierMap"
							[usersList]="usersList"
							[allUsersList]="allUsersList"
							[customerCarrier]="search.customerCarrier"
							[isCarrierVettingIntegrationEnabled]="isCarrierVettingIntegrationEnabled"
							[isCarrierOnboarded]="carrierVettingService.isCarrierOnboarded(search.carrierId)"
							style="width: 100%"
							[isExpanded]="step === i"
							[hideLastColumn]="hideLastColumn"
							[isKanbanView]="isKanbanView"
						>
						</app-pannel-header>
					</mat-expansion-panel-header>

					<ng-template [ngIf]="step == i">
						<app-pannel-body
							(customerCarrierUpdated)="
								search.customerCarrier = $event; setCustomerCarrierMatched()
							"
							(emitUserResponse)="
								submitUserFeedback($event); this.step = this.step == i ? null : ''
							"
							(feedbackClicked)="feedbackClicked.emit($event)"
							(openLaneDetails)="openLaneDetails.emit($event)"
							(recentFeedbackList)="recentFeedbackList.emit($event)"
							[capacitySearch]="search"
							[editPrimaryContact]="false"
							[searchTruckForm]="searchTruckForm"
						></app-pannel-body>
					</ng-template>
				</mat-expansion-panel>
				</div>
			</mat-accordion>
		</cdk-virtual-scroll-viewport>
	</div>
</div>

<!--
	CN-8312 V3 parity: the upgrade-plan card, no-network-msg card, "Request More
	Lanes" button, and the "we did not find any capacity" empty card all render
	below the carrier list and were appearing as an extra bordered container at
	the bottom of the V3 Recommended column (procured-carriers doesn't route
	through pannel-wrapper, so Engaged/Procured never had them). Hide them in
	Kanban view so the V3 Recommended column matches the cleaner Engaged /
	Procured layout.
-->
<div
	*ngIf="!isKanbanView && truckSearchResult != null && showUpgradePlanCard()"
	class="m-t-1"
	fxLayout="row"
	fxLayoutAlign="top left"
>
	<mat-card fxFlex="100">
		<mat-card-content class="primary-text font-size-16" fxLayoutAlign="center center">
			<div [innerHTML]="UPGRADE_MSG"></div>
		</mat-card-content>
	</mat-card>
</div>

<div
	*ngIf="!isKanbanView && truckSearchResult != null && IS_NOT_EMPTY(noNetworkCarriersMsg)"
	class="m-t-1"
	fxLayout="row"
	fxLayoutAlign="top left"
>
	<mat-card fxFlex="100">
		<mat-card-content class="primary-text font-size-16" fxLayoutAlign="center center">
			<div [innerHTML]="noNetworkCarriersMsg"></div>
		</mat-card-content>
	</mat-card>
</div>

<div *ngIf="!isKanbanView && showRequestLanes()" class="m-t-1" fxLayout="row" fxLayoutAlign="end center">
	<button (click)="requestLanes()" color="primary" mat-raised-button>Request More Lanes</button>
</div>

<div *ngIf="!isKanbanView && !isTruckSearch && !showSearchFilter()">
	<div class="full-width" fxLayout="row">
		<mat-card class="m-t-1" fxFlex>
			<mat-card-content fxLayoutAlign="center center">
				<h5>
					We did not find any capacity for your lane. Please try increasing the deadhead for more
					options.
				</h5>
			</mat-card-content>
		</mat-card>
	</div>
</div>

<ng-template #skeletonLoader>
	<div>
		<app-skeleton-loader [SHOW_PANEL]="true"></app-skeleton-loader>
	</div>
</ng-template>
